import { render, staticRenderFns } from "./EmployeeAndSingleQRCode.vue?vue&type=template&id=4fb385f2&"
import script from "./EmployeeAndSingleQRCode.js?vue&type=script&lang=js&"
export * from "./EmployeeAndSingleQRCode.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports